"use client";

import { onMessageListener, requestPermissionAndToken } from "@utils/firebase";
import { useEffect } from "react";
import { showOrderToast } from "./show-toast";
import { useCreateFirebaseMutation } from "@data/firebase/firebase.mutation";
import { useQueryClient } from "react-query";
import { API_ENDPOINTS } from "@utils/api/endpoints";

export function FirebaseNotification() {
//     const { mutate: createFirebase } = useCreateFirebaseMutation();
//     const queryClient = useQueryClient();
//     useEffect(() => {
//         requestPermissionAndToken().then((token) => {
//             if (token) {
//                 createFirebase({input: token })
//             }
//         });
//         onMessageListener((payload: any) => {
//             queryClient.invalidateQueries(API_ENDPOINTS.TOTAL_COUNT_HEADER);
//             queryClient.invalidateQueries(API_ENDPOINTS.NOTIFICATIONS);
//             queryClient.invalidateQueries(API_ENDPOINTS.LASTEST_NOTIFICATION);
//             queryClient.invalidateQueries(API_ENDPOINTS.NOTIFICATION_READ_IDS);
//             queryClient.invalidateQueries(API_ENDPOINTS.GET_TOTAL_NOTIFICATIONS);
//             queryClient.invalidateQueries(API_ENDPOINTS.TOTAL_COUNT_HEADER);
//             const data = payload?.data;
            
//             if (!data) return;
//             const order = {
//                 title: data.title,
//                 code: data.code,
//                 customer_name: data.customer_name,
//                 date: data.date,
//                 total: data.total
//             };
//             showOrderToast(order);
//         });
//   }, []);

  return null;
}
